// Confined artifact paths for GPU plan projections (U08c Block 5). Scene records
// carry query-free relative paths; only these two forms are fetchable. Bytes are
// still bound by the scene's SHA-256, length and identity checks.
const LEGACY_VIEWS = ['top', 'bottom', 'front', 'back', 'left', 'right'];
const STATIC_PATH = /^assets\/plan-projections\/[A-Za-z0-9_./-]+$/;
const PACKAGE_PATH = /^api\/asset-objects\/([1-9][0-9]{0,15})\/revisions\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/variants\/(default|v-[0-9a-f]{64})\/legacyPlan\/(top|bottom|front|back|left|right)$/;

/** Scene path of a published revision's monochrome plan document. */
export function packagePlanProjectionPath({ assetObjectId, revisionId, variantId }, viewId) {
  const path = `api/asset-objects/${assetObjectId}/revisions/${revisionId}/variants/${variantId}/legacyPlan/${viewId}`;
  if (!LEGACY_VIEWS.includes(viewId) || !PACKAGE_PATH.test(path)) throw new TypeError('Invalid plan projection reference');
  return path;
}

/** Fetch URL for a scene artifact path; anything else is rejected. */
export function planProjectionUrl(path) {
  if (typeof path !== 'string' || path.split('/').includes('..')) throw new Error('Ungültiger Projektionspfad.');
  if (STATIC_PATH.test(path)) return '/' + path;
  const match = PACKAGE_PATH.exec(path);
  if (!match) throw new Error('Ungültiger Projektionspfad.');
  const [, id, revision, variant, view] = match;
  return `/api/asset-objects/${id}/revisions/${revision}/variants/${variant}/legacyPlan?view=${view}`;
}
